import React, { useState } from 'react';

import gunHover from '../Assets/Banner/Marketing.webp';
import betterImg from '../Assets/Banner/better.jpeg';
import biggerImg from '../Assets/Banner/bigger.jpg';
//import gunGif from '../Assets/Gif/gun (1).svg';
//import glassGif from '../Assets/Gif/coffee-cup (1).svg';
import bgImage from '../Assets/IMG/BG_01.gif'; 


const hoverImages = {
  marketing: gunHover,
  better: betterImg,
  bigger: biggerImg,
};

const Banner = () => {
  const [hoveredWord, setHoveredWord] = useState(null);
  const [selectedImage, setSelectedImage] = useState(null);

  const handleImageClick = (word) => {
    setSelectedImage(word === selectedImage ? null : word); // toggle
  };

  return (
    <>
      <style>{`
        @media (max-width: 1024px) {
          .banner-heading h1 {
            font-size: 2.5rem !important;
          }
          .banner-heading h2 {
            font-size: 2rem !important;
          }
          .gun-icon, .glass-icon {
            width: 60px !important;
          }
        }

        @media (max-width: 600px) {
          .banner-heading h1 {
            font-size: 1.6rem !important;
          }
          .banner-heading h2 {
            font-size: 1.4rem !important;
          }
          .gun-icon {
            top: 20% !important;
            left: 40% !important;
          }
          .glass-icon {
            bottom: 15% !important;
            right: 40% !important;
          }
        }
      `}</style>

      <div
        style={{
          position: 'relative',
          backgroundColor: selectedImage ? 'transparent' : '',
          backgroundImage: selectedImage
            ? `url(${hoverImages[selectedImage]})`
            : `url(${bgImage})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          color: '#191e35',
          minHeight: '72vh',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          padding: '2rem 1rem',
          textAlign: 'center',
          overflow: 'hidden',
          
        }}
        className="banner-heading"
      >     
           
        {/* Decorative GIFs */}
        {!selectedImage && (
          <>
            {/* <img
              src={gunGif}
              alt="gun"
              className="gun-icon"
              style={{
                position: 'absolute',
                top: '27%',
                left: '14%',
                width: '90px',
                zIndex: 1,
              }}
            /> */}
            {/* <img
              src={glassGif}
              alt="glass"
              className="glass-icon"
              style={{
                position: 'absolute',
                bottom: '10%',
                right: '15%',
                width: '90px',
                zIndex: 1,
              }}
            /> */}
          </>
        )}

        {/* Text with hover and click */}
        <h1 style={{ fontWeight: 500, fontSize: '50px', margin: 0 }}>
          EVERY BRAND NEEDS A {' '}
          <span
            style={{ fontWeight: 'bold', cursor: 'pointer' }}
            onMouseEnter={() => setHoveredWord('marketing')}
            onMouseLeave={() => setHoveredWord(null)}
            onClick={() => handleImageClick('marketing')}
          >
           HERO
          </span>
        </h1>

        <h1 style={{ fontWeight: 500, fontSize: '50px', margin: 0 }}>
        WE JUST HAPPEN TO COME WITH  A {' '} 
          <span
            style={{ fontWeight: 'bold', cursor: 'pointer' }}
            onMouseEnter={() => setHoveredWord('better')}
            onMouseLeave={() => setHoveredWord(null)}
            onClick={() => handleImageClick('better')}
          >
            KILLER
          </span>
        </h1>

        <h2 style={{ fontWeight: 500, fontSize: '50px', margin: 0 }}>
           {' '}
          <span
            style={{ fontWeight: 'bold', cursor: 'pointer' }}
            onMouseEnter={() => setHoveredWord('bigger')}
            onMouseLeave={() => setHoveredWord(null)}
            onClick={() => handleImageClick('bigger')}
          >
           SOCIAL MEDIA STRATEGY!
          </span>
        </h2>

        {/* Hover Preview */}
        {hoveredWord && !selectedImage && (
          <img
            src={hoverImages[hoveredWord]}
            alt={hoveredWord}
            className="hover-img"
            style={{
              position: 'absolute',
              top: '50%',
              left: '50%',
              transform: 'translate(-50%, -50%)',
              width: '100%',
              height: '100%',
              objectFit: 'cover',
              zIndex: 2,
              opacity: 0.9,
              pointerEvents: 'none',
            }}
          />
        )}
      </div>
    </>
  );
};

export default Banner;
